import React from 'react';
import s from './ConstituencyCandidateVersus.scss';
import { IMAGE_URL } from '../../../constants';

const csValueMapping = {
  3: {
    name: 'Won',
    state: 'won',
  },
  1: {
    name: 'Leading',
    state: 'leading',
  },
  2: {
    name: 'Trailing',
    state: 'trailing',
  },
  4: {
    name: 'Runner Up',
    state: 'lost',
  },
  100: {
    name: 'Incumbent',
    state: 'incumbent',
  },
};

const midStatus = ({ candidates, loksabha = false }) => {
  let status = '';
  if ([3, 4].includes(candidates?.lw_status) && candidates?.inan) {
    if (candidates?.lwan === candidates?.inan) {
      status = `${candidates?.lwan} Retained Position`;
    } else if (candidates?.lwan !== candidates?.inan) {
      status = `${candidates?.lwan} Replaced ${candidates?.inan}`;
    }
    if (candidates?.lwan === 'BRS' && candidates?.inan === 'TRS') {
      status = `${candidates?.lwan} Retained Position`;
    }
  }
  if ([1, 2].includes(candidates?.lw_status)) {
    status = 'Counting In Progress';
  }
  if (
    loksabha &&
    !candidates?.inan &&
    candidates?.ey === 2019 &&
    (candidates?.sn === 'Telangana' || candidates?.sn === 'Andhra Pradesh')
  ) {
    status = 'Political scenarios evolved post 2014 elections';
  }
  if (status) {
    return <div className={s.resultInfo}>{status}</div>;
  }
  return null;
};

const ConstituencyCandidateVersus = ({
  candidates,
  toBeDecided,
  loksabha = false,
}) => (
  <div className={s.candidateWrap}>
    <div className={s.candidateWrapInner}>
      {candidates?.incn ? (
        <div className={s.candidateInfo}>
          <div className={s.cName} title={candidates?.incn}>
            {candidates?.incn}
          </div>
          <div className={`${s.cStatus} ${s[csValueMapping[100]?.state]}`}>
            {toBeDecided ? csValueMapping[100]?.name : 'Incumbent'}
          </div>
          <div
            className={s.cParty}
            style={{
              'border-color': candidates?.incc,
              color: candidates?.incc,
            }}
          >
            <span className={s.partyLogo}>
              <img
                src={`${IMAGE_URL}${candidates?.inpl || '45963157'}.cms`}
                alt={`${candidates?.inpl} Party Logo`}
              />
            </span>
            <span className={s.partyName}>{candidates?.inan}</span>
          </div>
        </div>
      ) : (
        <div className={s.candidateInfo}>
          <div className={s.cName} title={candidates?.lwcn}>
            {candidates?.lwcn}
          </div>
          <div
            className={`${s.cStatus} ${
              s[csValueMapping[candidates?.lw_status]?.state]
            }`}
          >
            {csValueMapping[candidates?.lw_status]?.name}
          </div>
          <div
            className={s.cParty}
            style={{ 'border-color': candidates.lwcc, color: candidates.lwcc }}
          >
            <span className={s.partyLogo}>
              <img
                src={`${IMAGE_URL}${candidates?.lwpl || '45963157'}.cms`}
                alt={`${candidates?.lwpl} Party Logo`}
              />
            </span>
            <span className={s.partyName}>{candidates?.lwan}</span>
          </div>
        </div>
      )}

      {toBeDecided && candidates?.incn ? (
        <>
          <div className={s.candidateInfo}>
            <div className={s.cName} title={candidates?.lwcn}>
              {candidates?.lwcn}
            </div>
            <div
              className={`${s.cStatus} ${
                s[csValueMapping[candidates?.lw_status]?.state]
              }`}
            >
              {csValueMapping[candidates?.lw_status]?.name}
            </div>
            <div
              className={s.cParty}
              style={{
                'border-color': candidates?.lwcc,
                color: candidates?.lwcc,
              }}
            >
              <span className={s.partyLogo}>
                <img
                  src={`${IMAGE_URL}${candidates?.lwpl || '45963157'}.cms`}
                  alt={`${candidates?.lwpl} Party Logo`}
                />
              </span>
              <span className={s.partyName}>{candidates?.lwan}</span>
            </div>
          </div>
        </>
      ) : (
        <div className={s.candidateInfo}>
          <div className={s.toBeDecided}>
            {candidates?.incn && 'To be Decided'}
          </div>
        </div>
      )}
    </div>
    {midStatus({
      candidates,
      loksabha,
      toBeDecided,
    })}
  </div>
);

export default ConstituencyCandidateVersus;
